import React, { useContext } from 'react'
import { EasybakeContext } from '../EasybakeProvider'
import Button from '@react/react-spectrum/Button'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import analytics from '../../config/analytics'
import {
    goToUrlTarget
} from '../../lib/easybake'
export default function BookMeetingButton () {
    const { page } = useContext(EasybakeContext)

    function bookMeeting(e) {
        analytics.sendEventName('click', `${page}:bookmeeting`)
        goToUrlTarget(__('url_book_meeting_mg'),"_blank") //Morgan
        // goToUrlTarget(__('url_book_meeting_ap'),"_blank") //Archy
        // goToUrlTarget(__('url_zendesk_ticket_new'),"_blank") // NOTE: zendesk
    }

    return (
        <React.Fragment>
            <Button
                label={__('nav_book_meeting')}
                onClick={(e) => bookMeeting(e)}
                variant="cta"
            />
            <br />
            <br />
        </React.Fragment>
    )
}
